<template>
  <section>
    <section class="subscribe">
      <div class="subscribe_wrapper">
        <div class="subscribe-heading">
          <img class="lazyload subscribe_coin" src="/coin.svg" alt="coin" />
          <div class="subscribe_heading">
            Subscribe to our Newsletter
            <span>Keep up with important business news everyday!</span>
          </div>
        </div>
        <div class="input_wrapper" v-if="!isSubscribed">
          <div class="mailpoet_form_popup_overlay"></div>
          <div
            id="mailpoet_form_2"
            class="mailpoet_form mailpoet_form_html mailpoet_form_tight_container"
          >
            <form
              @submit.prevent="onClick"
              target="_self"
              method="post"
              class="mailpoet_form mailpoet_form_form mailpoet_form_html"
            >
              <div class="mailpoet_paragraph">
                <input
                  type="email"
                  class="mailpoet_text"
                  name="data[form_field_MDU0NTgyNjA4NjQwX2VtYWls]"
                  title="Enter your email"
                  v-model="email"
                  style="
                    width: 100%;
                    background-color: #ffffff;
                    border-style: solid;
                    border-radius: 0px !important;
                    border-width: 0px;
                    border-color: #313131;
                    padding: 5px;
                    margin: 0 auto 0 0;
                    color: #2526ff;
                  "
                />
              </div>
              <div class="mailpoet_paragraph last">
                <input
                  type="submit"
                  @click="onClick"
                  :disabled="!isValid"
                  class="mailpoet_submit"
                  value="SUBSCRIBE"
                  style="
                    background-color: #ceddff;
                    border-style: solid;
                    border-radius: 0px !important;
                    border-width: 1px;
                    border-color: #2526ff;
                    padding: 8px;
                    margin: 0 auto 0 0;
                    font-family: 'Poppins';
                    font-size: 14px;
                    line-height: 1.5;
                    height: auto;
                    color: #2526ff;
                  "
                /><span class="mailpoet_form_loading"
                  ><span class="mailpoet_bounce1"></span
                  ><span class="mailpoet_bounce2"></span
                  ><span class="mailpoet_bounce3"></span
                ></span>
              </div>
              <div class="mailpoet_message">
                <p class="mailpoet_validate_success" style="display: none">
                  Check your inbox or spam folder to confirm your subscription.
                </p>
                <p class="mailpoet_validate_error" style="display: none"></p>
              </div>
            </form>
          </div>
        </div>
        <div class="input_wrapper" v-else>Subscribed successfully!</div>
      </div>
    </section>
    <footer>
      <div class="footer_wrapper">
        <img src="/logo.svg" alt="logo" class="lazyload footer_logo" />
        <ul class="footer_links">
          <li><router-link to="/about">About Us</router-link></li>
          <li>
            <router-link to="/privacy-policy">Privacy Policy</router-link>
          </li>
          <li><router-link to="/cookie-policy">Cookies Policy</router-link></li>
          <li>
            <router-link to="/terms-conditions"
              >Terms &amp; Conditions</router-link
            >
          </li>
        </ul>
      </div>
      <div class="mobile_footer_wrapper">
        <div class="footer_links_container">
          <img src="/logo.svg" alt="logo" class="lazyload footer_logo" />
          <ul class="footer_links">
            <li><router-link to="/about">About Us</router-link></li>
            <li>
              <router-link to="/privacy-policy">Privacy Policy</router-link>
            </li>
            <li>
              <router-link to="/cookie-policy">Cookies Policy</router-link>
            </li>
            <li>
              <router-link to="/terms-conditions"
                >Terms &amp; Conditions</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </footer>
    <div class="copyright">
      Copyright 2021 ©YuanPay group. All Right Reserved.
    </div>
    <a id="scroll-to-top" href="#" title="Scroll to Top" style="display: none"
      >Top</a
    >
    <link
      rel="stylesheet"
      id="mailpoet_custom_fonts_css-css"
      href="https://fonts.googleapis.com/css?family=Abril+FatFace%3A400%2C400i%2C700%2C700i%7CAlegreya%3A400%2C400i%2C700%2C700i%7CAlegreya+Sans%3A400%2C400i%2C700%2C700i%7CAmatic+SC%3A400%2C400i%2C700%2C700i%7CAnonymous+Pro%3A400%2C400i%2C700%2C700i%7CArchitects+Daughter%3A400%2C400i%2C700%2C700i%7CArchivo%3A400%2C400i%2C700%2C700i%7CArchivo+Narrow%3A400%2C400i%2C700%2C700i%7CAsap%3A400%2C400i%2C700%2C700i%7CBarlow%3A400%2C400i%2C700%2C700i%7CBioRhyme%3A400%2C400i%2C700%2C700i%7CBonbon%3A400%2C400i%2C700%2C700i%7CCabin%3A400%2C400i%2C700%2C700i%7CCairo%3A400%2C400i%2C700%2C700i%7CCardo%3A400%2C400i%2C700%2C700i%7CChivo%3A400%2C400i%2C700%2C700i%7CConcert+One%3A400%2C400i%2C700%2C700i%7CCormorant%3A400%2C400i%2C700%2C700i%7CCrimson+Text%3A400%2C400i%2C700%2C700i%7CEczar%3A400%2C400i%2C700%2C700i%7CExo+2%3A400%2C400i%2C700%2C700i%7CFira+Sans%3A400%2C400i%2C700%2C700i%7CFjalla+One%3A400%2C400i%2C700%2C700i%7CFrank+Ruhl+Libre%3A400%2C400i%2C700%2C700i%7CGreat+Vibes%3A400%2C400i%2C700%2C700i%7CHeebo%3A400%2C400i%2C700%2C700i%7CIBM+Plex%3A400%2C400i%2C700%2C700i%7CInconsolata%3A400%2C400i%2C700%2C700i%7CIndie+Flower%3A400%2C400i%2C700%2C700i%7CInknut+Antiqua%3A400%2C400i%2C700%2C700i%7CInter%3A400%2C400i%2C700%2C700i%7CKarla%3A400%2C400i%2C700%2C700i%7CLibre+Baskerville%3A400%2C400i%2C700%2C700i%7CLibre+Franklin%3A400%2C400i%2C700%2C700i%7CMontserrat%3A400%2C400i%2C700%2C700i%7CNeuton%3A400%2C400i%2C700%2C700i%7CNotable%3A400%2C400i%2C700%2C700i%7CNothing+You+Could+Do%3A400%2C400i%2C700%2C700i%7CNoto+Sans%3A400%2C400i%2C700%2C700i%7CNunito%3A400%2C400i%2C700%2C700i%7COld+Standard+TT%3A400%2C400i%2C700%2C700i%7COxygen%3A400%2C400i%2C700%2C700i%7CPacifico%3A400%2C400i%2C700%2C700i%7CPoppins%3A400%2C400i%2C700%2C700i%7CProza+Libre%3A400%2C400i%2C700%2C700i%7CPT+Sans%3A400%2C400i%2C700%2C700i%7CPT+Serif%3A400%2C400i%2C700%2C700i%7CRakkas%3A400%2C400i%2C700%2C700i%7CReenie+Beanie%3A400%2C400i%2C700%2C700i%7CRoboto+Slab%3A400%2C400i%2C700%2C700i%7CRopa+Sans%3A400%2C400i%2C700%2C700i%7CRubik%3A400%2C400i%2C700%2C700i%7CShadows+Into+Light%3A400%2C400i%2C700%2C700i%7CSpace+Mono%3A400%2C400i%2C700%2C700i%7CSpectral%3A400%2C400i%2C700%2C700i%7CSue+Ellen+Francisco%3A400%2C400i%2C700%2C700i%7CTitillium+Web%3A400%2C400i%2C700%2C700i%7CUbuntu%3A400%2C400i%2C700%2C700i%7CVarela%3A400%2C400i%2C700%2C700i%7CVollkorn%3A400%2C400i%2C700%2C700i%7CWork+Sans%3A400%2C400i%2C700%2C700i%7CYatra+One%3A400%2C400i%2C700%2C700i&amp;ver=5.5.5"
      type="text/css"
      media="all"
    />
  </section>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      isSubscribed: false,
    };
  },
  computed: {
    isValid() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },
  },
  methods: {
    onClick() {
      setTimeout(() => {
        this.isSubscribed = true;
      }, 800);
    },
  },
};
</script>
